export const APP = "APP";
export const FIREBASE_TOKEN = "FIREBASE_TOKEN";
export const SHOW_LOADER = "SHOW_LOADER";
export const STRIPE_CLIENT_ID = "STRIPE_CLIENT_ID";
export const REVERIE_PARAMS = "REVERIE_PARAMS";
export const LOGIN_PROVIDER = "LOGIN_PROVIDER";
export const SET_PLAYER = "SET_PLAYER";
